import { observer } from "mobx-react";
import * as React from "react";
import { Button, FormGroup, InputGroup } from "@blueprintjs/core";
import { observable } from "mobx";
import { MDBCol, MDBRow } from "mdbreact";
import { AppStore } from "../../stores/AppStore";
import { api } from "../../api";
import { LoginStore } from "../../stores/login/LoginStore";

@observer
export class RestorePasswordPage extends React.Component<{}, {}> {

  obs = observable({
    email: "" as string,
    password: "" as string,
    mostra_senha: false as boolean,
    emptyFieldEmail: true as boolean,
    validateFieldEmail: true as boolean,
    validateBackEndEmail: true as boolean,
    loading: false as boolean
  })

  constructor(props: any) {
    super(props);
  }

  isValidEmail() {

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return emailRegex.test(this.obs.email);

  }


  async handleRecoverPassword() {
    this.obs.emptyFieldEmail = true
    this.obs.validateFieldEmail = true
    this.obs.validateBackEndEmail = true
    this.obs.loading = true

    if (this.obs.email == "") {
      this.obs.loading = false
      return this.obs.emptyFieldEmail = false
    } else {
      if (!this.isValidEmail()) {
        this.obs.loading = false
        return this.obs.validateFieldEmail = false;
      }

      let data = { "email": this.obs.email }
      let resp = await LoginStore.handleRecuperaSenha(data)
      if (!resp.ok) {
        this.obs.loading = false
        return this.obs.validateBackEndEmail = false
      } else {
        this.obs.loading = false
        AppStore.setLocation("/senha-alterada");
      }
    }
  }

  render() {

    return (
      <>
        <div className="container-fluid container-login">
          <MDBRow>
            <MDBCol md="6" className="form-login" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
              <div className="login-img">
                <img src="/images/logo-novo.png" className="img-responsive" />
              </div>

              <h3 className="title-login" style={{ textAlign: "center" }}>Recuperar Senha</h3>

              <FormGroup
                className="form-group"
                label="E-mail">
                <InputGroup type="text" onChange={(e: any) => this.obs.email = e.target.value} placeholder="Seu e-mail de acesso" className="input-email" />
                {!this.obs.emptyFieldEmail && <div style={{ color: 'red' }}><p>Campo obrigatório</p></div>}
                {!this.obs.validateFieldEmail && <div style={{ color: 'red' }}><p>E-mail inválido</p></div>}
                {!this.obs.validateBackEndEmail && <div style={{ color: 'red' }}><p>E-mail não cadastrado</p></div>}
              </FormGroup>

              <div className="actions-form" style={{ marginBottom: 20 }}>
                {!this.obs.loading
                  ? <Button className="btn btn-login" onClick={(e) => this.handleRecoverPassword()}>Recuperar minha Senha</Button>
                  : <Button className="btn btn-login">
                    <i className="fa fa-spinner fa-spin"></i>
                    Recuperando
                  </Button>
                }
              </div>

              <div style={{ textAlign: "center", fontSize: 15, marginTop: "auto", marginBottom: 20 }}>
                <div className="name-ent">Gerenciador Fiscal e Tributário Ltda.</div>
                <div>© 2023 . Todos os Direitos Reservados.</div>
              </div>

            </MDBCol>

            <MDBCol md="6" className="fundo-login">
              <div className="fundo-bg"></div>
            </MDBCol>

          </MDBRow>

        </div>
      </>
    );
  }
}

export default RestorePasswordPage;
